export const enum Namespace {
  Auth = "Auth",
  Player = "Player",
  Alert = "Alert",
  ChannelChange = "channelChange",
  Overlay = "Overlay",
  SideBar = "SideBar",
  ChannelsPage = "ChannelsPage",
  HomePage = "HomePage",
  Buffet = "Buffet",
  Settings = "Settings",
  Vod = "Vod"
}
